<ng-container *ngIf="!readonly">
  <div class="dropzone flex flex-column align-items-center" [class.dropzone-hover]="isDragOver" (drop)="onDrop($event)"
    (click)="fileInput.click()" (dragover)="onDragOver($event)" (dragleave)="onDragLeave()">
    <input #fileInput hidden type="file" [accept]="allowedFileTypes.join(',')" (change)="handleFileSelected($event)"
      [multiple]="multiple" />

    <i data-feather="upload-cloud" class="icon-upload-cloud" appFeatherIcon [size]="30"></i>

    <span class="description">Clique para fazer <span class="text-blue">upload</span> ou arraste e
      solte
    </span>

    <span class="formats">{{ getFileTypesDescription() }}</span>
  </div>
</ng-container>

<ng-container *ngIf="files.length > 0 && !readonly">
  <div class="file-list mt-1">
    <ul class="list-group list-group-flush">
      <li class="list-group-item" *ngFor="let fileUpload of files; let i = index">
        <i data-feather="file" class="icon-file" appFeatherIcon></i>

        <span class="flex-1">{{ fileUpload.file.name }}</span>

        <ng-container *ngIf="fileUpload.inProgress">
          <ngb-progressbar type="primary" [value]="fileUpload.progress"></ngb-progressbar>
        </ng-container>

        <div class="actions">
          <ng-container *ngIf="i !== fileDeleteIndex">
            <button class="btn btn-icon" (click)="handleRemoveFile(i)" ngbTooltip="Excluir"
              [disabled]="fileUpload.inProgress">
              <i data-feather="trash" appFeatherIcon></i>
            </button>
          </ng-container>
          <ng-container *ngIf="i === fileDeleteIndex">
            <button class="btn btn-sm btn-link btn-remove-confirm text-danger text-xs"
              (click)="handleConfirmRemoveAmount()" [disabled]="fileUpload.inProgress">
              Deletar?
            </button>
          </ng-container>
        </div>
      </li>
    </ul>
  </div>
</ng-container>

<ng-container *ngIf="readonly && !multiple">
  <div class="file-item flex align-items-center gap-2 p-2 border rounded" [class.cursor-pointer]="fileName"
    [title]="fileName" (click)="getFile()">
    <i data-feather="file" class="file-icon"></i>
    <span class="file-name">
      {{ fileName }}
    </span>
  </div>
</ng-container>